<div>
    <cc-checkbox
        class="select-all"
        [(value)]="value"
        (valueChange)="onClick($event)">
    </cc-checkbox>
</div>
